module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "software-installation"
  }, [_c('help'), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Software Installation Instructions (SII)"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Follow these instructions to install your required software per term'),
      expression: "'Follow these instructions to install your required software per term'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.isInPaths('9200') || _vm.isAdmin) ? _c('div', {
    staticClass: "software-panel"
  }, [_c('h3', [_vm._v("Houdini Program Software")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'houdini'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Houdini\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'autodesk'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Autodesk Education Account\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'maya'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Maya\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'arnold'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Arnold for Houdini\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'mari'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Mari (T1)\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'nuke-houdini'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Nuke\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'substancepainter'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Substance Painter\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'photoshop'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Photoshop\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'substancedesigner'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Substance Designer (T2, T3, T4)\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'unreal'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Unreal Engine (T2, T3, T4)\n                        ")])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isInPaths('9200') || _vm.isAdmin) ? _c('div', {
    staticClass: "software-panel"
  }, [_c('h3', [_vm._v("Fundamentals Term")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'autodesk'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Autodesk Education Account\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'winrar'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install WinRAR\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'zoom'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Zoom\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'mari'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Mari\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'nuke'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Nuke\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'maya'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Maya\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'v-ray',
          query: {
            software_page: true
          }
        }
      }
    }
  }, [_vm._v("\n                            Install V-Ray\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'photoshop'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Photoshop\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'substancepainter'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Substance Painter\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'zbrush'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install ZBrush\n                        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || !_vm.isInPaths('9200')) ? _c('div', {
    staticClass: "software-panel",
    class: {
      'disabled': _vm.disabled
    }
  }, [_c('h3', [_vm._v("Intermediate, Advanced, Portfolio Production Terms")]), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('6627,6643,9130,9131')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'unreal'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Unreal Engine\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('6627,6643,6644,9131,9130')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'substancedesigner'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Substance Designer\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('6627,6643')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'marmoset'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Marmoset\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('9130')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'marmoset'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Marmoset (T2)\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('6642,6644,9131,9130,6627')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'agisoft'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Agisoft Photoscan\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('6642,6644,9131,9130')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'nuke'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Nuke\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('6627,6642,6643,6644,9131,9130')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'marvelous'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Marvelous Designer\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('9131,6627')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'gaea'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Gaea 2.0 (T2)\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('9130,6643')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'wrap'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Wrap\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('9131')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'houdini'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install Houdini (T3 + T4)\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || _vm.isInPaths('6627')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "btn btn-success software-button",
    attrs: {
      "to": {
        name: 'help-page',
        params: {
          slug: 'speedtree'
        },
        query: {
          software_page: true
        }
      }
    }
  }, [_vm._v("\n                            Install SpeedTree\n                        ")])], 1)]) : _vm._e()]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/houdini.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/autodesk.jpg?v=2.1")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/maya.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/arnold.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/mari.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/nuke.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/substance-painter.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/photoshop.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/substance-designer.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/unreal.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/autodesk.jpg?v=2.1")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/winrar.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/zoom.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/mari.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/nuke.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/maya.jpg?v=2.1")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/v-ray.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/photoshop.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/substance-painter.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/zbrush.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/unreal.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/substance-designer.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/marmoset.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/marmoset.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/agisoft-photoscan.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/nuke.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/marvelous-designer.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/gaea.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/wrap.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/houdini.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "software-image",
    attrs: {
      "src": require("../assets/img/software/speedtree.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3de2872b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SoftwareInstallation.vue
// module id = 2026
// module chunks = 2